module.exports = __webpack_public_path__ + "img/placeholder-image-upload.e4c0bad7.png";